export default state => state.savedItems.isWarningDismissed;
